import { ACTIONS as ACTION_TYPES } from '../../const/actions';
export const ACTIONS = {...ACTION_TYPES};